export type IPDPackageType = 'PACKAGE_1' | 'PACKAGE_2' | 'PACKAGE_3';

export const IPD_PACKAGE_TYPE_OPTIONS: { value: IPDPackageType; label: string; description: string }[] = [
  {
    value: 'PACKAGE_1',
    label: 'Package 1 — Everything included',
    description: 'Medicines, lab tests, and room are covered by the package amount.',
  },
  {
    value: 'PACKAGE_2',
    label: 'Package 2 — Medicine & lab excluded',
    description: 'Medicines and lab tests are billed separately; package covers surgery/procedure and room.',
  },
  {
    value: 'PACKAGE_3',
    label: 'Package 3 — Medicine excluded',
    description: 'Medicines are billed separately; lab tests remain in the package.',
  },
];

export function packageTypeLabel(type?: IPDPackageType | null): string {
  return IPD_PACKAGE_TYPE_OPTIONS.find((o) => o.value === type)?.label ?? 'Package';
}

export function isPackagePatient(totalPackageCost?: number | null): boolean {
  return totalPackageCost != null && Number(totalPackageCost) > 0;
}

export function resolvePackageType(
  admission?: { totalPackageCost?: number | null; packageType?: IPDPackageType | null } | null
): IPDPackageType | null {
  if (!admission || !isPackagePatient(admission.totalPackageCost)) return null;
  return admission.packageType ?? 'PACKAGE_1';
}

export function isFullyInclusivePackagePatient(
  admission?: { totalPackageCost?: number | null; packageType?: IPDPackageType | null } | null
): boolean {
  const packageType = resolvePackageType(admission);
  return packageType === 'PACKAGE_1';
}

export function isMedicineIncludedInPackage(packageType: IPDPackageType | null): boolean {
  return packageType === 'PACKAGE_1' || packageType === 'PACKAGE_3';
}

export function isLabIncludedInPackage(packageType: IPDPackageType | null): boolean {
  return packageType === 'PACKAGE_1' || packageType === 'PACKAGE_3';
}

export function isPharmaIncludedInPackage(
  admission?: { totalPackageCost?: number | null; packageType?: IPDPackageType | null } | null,
  billSeparately?: boolean | null
): boolean {
  const packageType = resolvePackageType(admission);
  if (!packageType) return false;
  if (!isMedicineIncludedInPackage(packageType)) return false;
  return billSeparately !== true;
}
